export default {
  BT_HDP: "Handicap | HDP",
  BT_OU: "Besar/Kecil | O/U",
  BT_ML: "Moneyline",
  BT_1X2: "1X2",
  BT_1X2HDP: "Handicap 3 arah",
  BT_CS: "Skor Yang Tepat",
  BT_OE: "Ganjil/Genap | Ganjil/Genap",
  BT_DC: "Peluang Ganda",
  BT_HTFT: "Babak Pertama/Waktu Penuh",
  BT_FGLG: "Gol Pertama/Gol Terakhir",
  BT_TG: "Total Gol",
  BT_OR: "Outright",
  BT_ORZ: "Outright",

  BT_ANB: "Away No Bet",
  BT_BS: "Keduanya/Salah Satu/Tidak Satu Pun mencetak skor",
  BT_CL: "Catatan Bersih",
  BT_DNB: "Taruhan Tanpa Seri",
  BT_HNB: "Home No Bet",
  BT_TWTN: "Menang Tanpa Kebobolan Gol",

  BT_HDPF: "FT. Handicap | FT. HDP",
  BT_OUF: "FT. Besar/Kecil | FT. O/U",
  BT_MLF: "FT. Moneyline | FT. ML",
  BT_1X2F: "FT. 1X2",
  BT_1X2HDPF: "FT. Handicap 3 arah",
  BT_CSF: "FT. Skor Yang Tepat",
  BT_OEF: "FT. Ganjil/Genap | FT. O/E",
  BT_DCF: "FT. Peluang Ganda",
  BT_FGLGF: "FT. Gol Pertama/Gol Terakhir",
  BT_TGF: "FT. Total Gol",

  BT_HDPH: "HT. Handicap | HT. HDP",
  BT_OUH: "HT. Besar/Kecil | HT. O/U",
  BT_MLH: "HT. Moneyline | HT. ML",
  BT_1X2H: "HT. 1X2",
  BT_1X2HDPH: "HT. Handicap 3 arah",
  BT_CSH: "HT. Skor Yang Tepat",
  BT_OEH: "HT. Ganjil/Genap",
  BT_DCH: "HT. Peluang Ganda",
  BT_FGLGH: "HT. Gol Pertama/Gol Terakhir",
  BT_TGH: "HT. Total Gol",
  BT_O: "Besar",
  BT_U: "Kecil",

  BT_HDPOU: "HDP & OU",
  BT_PARLAY: "Taruhan Campuran",
  BT_FT: "Waktu Penuh",
  BT_1H: "Babak Pertama",
  BT_2H: "Babak Kedua",

  BT_FG: "Gol Pertama",
  BT_LG: "Gol Terakhir",
  BT_HFG: "Tim Kandang Gol Pertama",
  BT_AFG: "Tim Tandang Gol Pertama",
  BT_HLG: "Tim Kandang Gol Terakhir",
  BT_ALG: "Tim Tandang Gol Terakhir",
  BT_NG: "Tidak Ada Gol",
  BT_HY: "Tim Kandang Ya",
  BT_HN: "Tim Kandang Tidak",
  BT_AY: "Tim Tandang Ya",
  BT_AN: "Tim Tandang Tidak",
  BT_H: "Tim Kandang",
  BT_A: "Tim Tandang",
  BT_D: "Seri",
  BT_HD_DC: "Tim Kandang atau Seri",
  BT_HA_DC: "Tim Kandang atau Tim Tandang",
  BT_DA_DC: "Tim Tandang atau Seri",
  BT_HH: "Tim Kandang/Tim Kandang",
  BT_HD: "Tim Kandang/Seri",
  BT_HA: "Tim Kandang/Tim Tandang",
  BT_DH: "Seri/Tim Kandang",
  BT_DD: "Seri/Seri",
  BT_DA: "Seri/Tim Tandang",
  BT_AH: "Tim Tandang/Tim Kandang",
  BT_AD: "Tim Tandang/Seri",
  BT_AA: "Tim Tandang/Tim Tandang",

  BT_Y: "Ya",
  BT_N: "Tidak",

  BT_LIVE: "LANGSUNG",
  BT_HT: "H.Time",
  BT_DELAYED: "Menunda",
  BT_PEN: "PEN",

  BT_FT1: "FT.1",
  BT_FT2: "FT.2",
  BT_FTX: "FT.X",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "Keduanya",
  BT_ONE: "Satu",

  BS_HDP: "FT Handicap",
  BS_HDPH: "HT. Handicap",
  BS_OU: "FT. Besar/Kecil",
  BS_OUH: "HT. Besar/Kecil",
  BS_OE: "FT. Ganjil/Genap",
  BS_OEH: "HT. Ganjil/Genap",
  BS_1X2: "FT. 1X2",
  BS_1X2H: "HT. 1X2",
  BS_ML: "FT Moneyline",
  BS_MLH: "HT. Moneyline",
  BS_1X2HDP: "FT. Handicap 3 arah",
  BS_1X2HDPH: "HT. Handicap 3 arah",
  BS_CS: "FT. Skor Yang Tepat",
  BS_CSH: "HT. Skor Yang Tepat",
  BS_DC: "FT. Peluang Ganda",
  BS_DCH: "HT. Peluang Ganda",
  BS_FGLG: "FT. Gol Pertama/Gol Terakhir",
  BS_FGLGH: "HT. Gol Pertama/Gol Terakhir",
  BS_TG: "FT. Total Gol",
  BS_TGH: "HT. Total Gol",
  BS_ANB: "Away No Bet",
  BS_HTFT: "Babak Pertama/Waktu Penuh",
  BS_BS: "Keduanya/Salah Satu/Tidak Satu Pun mencetak skor",
  BS_CL: "Catatan Bersih",
  BS_DNB: "Taruhan Tanpa Seri",
  BS_HNB: "Home No Bet",
  BS_TWTN: "Menang Tanpa Kebobolan Gol",
  BS_OR: "Outright",
  BS_ORZ: "Outright",
  
  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",
  LOT_FT: "FT",
  LOT_HT: "HT",

  BT_ALLBT: "All Bet Type",

  _1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "K.O. By",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "WIN",
  GH_1X20: "WIN",
  GH_1X2HDP: "PLACE/SHOW",
  GH_1X2HDP2: "PLACE",
  GH_1X2HDP4: "SHOW",
  GH_OVER: "OVER (4,5,6)",
  GH_UNDER: "UNDER (1,2,3)",
  GH_ODD: "ODD (1,3,5)",
  GH_EVEN: "EVEN (2,4,6)",
  GH_OU1: "OVER (4,5,6)",
  GH_OU2: "UNDER (1,2,3)",
  GH_OE1: "ODD (1,3,5)",
  GH_OE2: "EVEN (2,4,6)",

  ROOM_A: "Open",
  ROOM_0: "Active",
  ROOM_1: "Closed",
  ROOM_2: "Cancel",
  ROOM_3: "Ended",
  ROOM_4: "Stop Betting",
  ROOM_10: "All",

  ROOM_T0: "All",
  ROOM_T1: "Public Room",
  ROOM_T2: "Private Room",
  ROOM_T3: "Play to Earn",

  joinRoom1: "Join Public Room",
  joinRoom2: "Join Private Room",
  joinRoom3: "Join Play Room",
  createRoom1: "Create Public Room",
  createRoom2: "Create Private Room",
  createRoom3: "Create Play Room",
  Champion: "Champion",
  FirstRunnerUp: "First Runner Up",
  SecondRunnerUp: "Second Runner Up",

  BT_OEHM: "Home Odd/Even | Home O/E",
  BT_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BT_OEAW: "Away Odd/Even | Away O/E",
  BT_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  BS_OEHM: "FT. Home Odd/Even | FT. Home O/E",
  BS_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BS_OEAW: "FT. Away Odd/Even | FT. Away O/E",
  BS_OEAWH: "FH. Away Odd/Even | FH. Away O/E",
  
  MB_OVER: "OVER (4,5,6)",
  MB_UNDER: "UNDER (1,2,3)",
  MB_ODD: "ODD (1,3,5)",
  MB_EVEN: "EVEN (2,4,6)",
};